let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3s72Y")).then(() => parcelRequire('k5jfD'));